import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="hero">
      <div className="container hero-content animate-fadeInUp">
        <div className="hero-eyebrow">X-TERRA MINING PLATFORM</div>
        <h1 className="hero-title">
          Power Your Future with{' '}
          <span className="text-gradient">X-Terra Mining</span>
        </h1>
        <p className="hero-subtitle">
          Mine XT Tokens through the X-Terra Mining Platform and become part of a growing
          blockchain ecosystem focused on innovation and renewable energy.
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary btn-lg pulse-glow" onClick={() => navigate('/dashboard')}>
            Start Mining →
          </button>
          <button className="btn btn-secondary btn-lg" onClick={() => navigate('/xt-token')}>
            📄 XT Token & Whitepaper
          </button>
          <button
            className="btn btn-ghost btn-lg"
            onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Learn More
          </button>
        </div>
        <div style={{ marginTop: 12, fontSize: 12, color: 'var(--text-muted)' }}>
          Want to download the Whitepaper or Plan? Open the XT Token page above — best done in Chrome / Safari for direct PDF downloads.
        </div>
      </div>
    </section>
  );
}
